const testimonials = [
  {
    name: "Carlos Quispe",
    role: "Dueño de Cevichería El Rímac",
    avatar: "https://readdy.ai/api/search-image?query=peruvian%20middle%20aged%20man%20smiling%20friendly%20face%20portrait%20professional%20headshot%20warm%20background&width=80&height=80&seq=20&orientation=squarish",
    text: "Pensé que era otro PDF más, pero este software me organizó todo el marketing de mi cevichería. En 2 semanas ya tenía promos que la gente compartía sola.",
    highlight: "2 semanas de resultados",
  },
  {
    name: "Milagros Torres",
    role: "Emprendedora de Ropa por Mayor",
    avatar: "https://readdy.ai/api/search-image?query=peruvian%20young%20woman%20entrepreneur%20smiling%20friendly%20face%20portrait%20professional%20headshot%20warm%20background&width=80&height=80&seq=21&orientation=squarish",
    text: "Los scripts de WhatsApp son una locura. Antes me dejaban en visto, ahora cierro ventas en el mismo chat. Recuperé mi inversión el primer día.",
    highlight: "Recuperó inversión el día 1",
  },
  {
    name: "Roberto Mamani",
    role: "Ferretería Mamani e Hijos",
    avatar: "https://readdy.ai/api/search-image?query=peruvian%20mature%20man%20business%20owner%20smiling%20friendly%20face%20portrait%20professional%20headshot%20warm%20background&width=80&height=80&seq=22&orientation=squarish",
    text: "Yo no sé nada de tecnología y lo usé sin problema. El generador de IA me hace las promos para fechas especiales en segundos. Mis ventas subieron 40%.",
    highlight: "+40% en ventas",
  },
];

export default function TestimonialsSection() {
  return (
    <section id="testimonios" className="relative bg-[#0B0F19] py-20 md:py-28 overflow-hidden">
      <div className="absolute top-0 left-0 w-[400px] h-[400px] bg-[#7C3AED]/10 rounded-full blur-[100px] pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-orange-500/8 rounded-full blur-[100px] pointer-events-none" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <p className="text-[#a78bfa] text-sm font-semibold uppercase tracking-widest mb-3">
            Resultados Reales
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-white leading-tight mb-4">
            Estrategias probadas en el{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-orange-300">
              mercado real.
            </span>
          </h2>
          <p className="text-white/50 text-base max-w-xl mx-auto">
            Negocios peruanos reales que ya están usando NegoIA para vender más cada día.
          </p>
        </div>

        {/* Testimonials grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="group relative">
              <div className="absolute inset-0 bg-[#7C3AED]/10 rounded-2xl blur-xl opacity-0 group-hover:opacity-100 transition-all duration-500" />
              <div className="relative bg-white/5 backdrop-blur-md border border-white/15 rounded-2xl p-6 h-full flex flex-col transition-all duration-300 group-hover:bg-white/8 group-hover:-translate-y-1">
                {/* Stars */}
                <div className="flex items-center gap-1 mb-4">
                  {[...Array(5)].map((_, j) => (
                    <i key={j} className="ri-star-fill text-orange-400 text-sm"></i>
                  ))}
                </div>

                {/* Highlight badge */}
                <div className="inline-flex items-center gap-1.5 bg-emerald-500/15 border border-emerald-500/30 text-emerald-400 text-xs font-bold px-2.5 py-1 rounded-full mb-4 w-fit">
                  <i className="ri-arrow-up-line text-xs"></i>
                  {t.highlight}
                </div>

                {/* Quote */}
                <p className="text-white/70 text-sm leading-relaxed flex-1 mb-6">
                  &ldquo;{t.text}&rdquo;
                </p>

                {/* Author */}
                <div className="flex items-center gap-3 pt-4 border-t border-white/10">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-10 h-10 rounded-full object-cover object-top border-2 border-[#7C3AED]/50"
                  />
                  <div>
                    <p className="text-white font-bold text-sm">{t.name}</p>
                    <p className="text-white/40 text-xs">{t.role}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust badges */}
        <div className="mt-12 flex flex-wrap items-center justify-center gap-6 md:gap-10">
          {[
            { icon: "ri-shield-check-fill", text: "Pago 100% Seguro" },
            { icon: "ri-refresh-line", text: "Garantía 7 días" },
            { icon: "ri-lock-fill", text: "Acceso Inmediato" },
            { icon: "ri-customer-service-2-fill", text: "Soporte en Español" },
          ].map((badge, i) => (
            <div key={i} className="flex items-center gap-2 text-white/50">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${badge.icon} text-[#a78bfa] text-base`}></i>
              </div>
              <span className="text-sm font-medium">{badge.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
